import React from 'react';
import styled from '@emotion/styled';
import { rem } from 'polished';
import { colors } from '../../core/styles/theme/default';
import Spacer from '../../helpers/Spacer';
import { H4, Link } from '../../primitives';

const StyledTeaser = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  cursor: pointer;
`;

const StyledTeaserImage = styled.div`
  display: block;
  width: 100%;
  padding-bottom: 56.25%;
  position: relative;
  background: linear-gradient(
    90deg,
    rgba(37, 55, 100, 0.9) 0%,
    rgba(37, 55, 100, 0.6) 100%
  );
`;

const StyledTeaserContent = styled.div`
  border: ${rem(1)} solid ${colors.grue300};
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: ${rem(24)};
  border-radius: 0 0 ${rem(4)} ${rem(4)};
`;

const StyledTeaserTitle = styled(H4)``;

const StyledImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  backface-visibility: hidden;
`;

const StyledLink = styled(Link)`
  margin-top: auto;
  color: ${colors.nightBlue500};

  .m-richtext & {
    text-decoration: none;
  }
`;

const TeaserAusAltMachNeu = ({
  data: { Title, ImageAfterName, seeDetailsText, href },
}: TeaserAusAltMachNeuProps) => {
  return (
    <>
      <StyledTeaser
        className="animate"
        onClick={(e) => {
          if (!(e.target as HTMLElement).closest('a')) {
            e.currentTarget.querySelector('a')?.click();
          }
        }}
      >
        <StyledTeaserImage>
          <StyledImage
            src={ImageAfterName}
            decoding="async"
            loading="lazy"
            alt={`${Title} image`}
          />
        </StyledTeaserImage>
        <StyledTeaserContent>
          <StyledTeaserTitle>{Title}</StyledTeaserTitle>
          <Spacer space="gamma" />
          <StyledLink
            linkText={seeDetailsText}
            link={{
              href,
              title: seeDetailsText,
            }}
            variant="internal"
          />
        </StyledTeaserContent>
      </StyledTeaser>
    </>
  );
};

type TeaserAusAltMachNeuProps = {
  data: {
    Title: string;
    ImageAfterName: string;
    seeDetailsText: string;
    href: string;
  };
};

export default TeaserAusAltMachNeu;
